module.exports = __webpack_public_path__ + "img/1-424-424.6e80aa6b.png";